import { useDispatch } from 'react-redux'
import { showAlert } from '../actions/AlertActions'

export const useDisplayErrorToast = () => {
    const dispatch = useDispatch()

    const displayErrorToast = (message, errorsList , defaultt) => {
        if (!message || !errorsList) return
        const error = errorsList.find((item) => item?.key == message)
        if ( (defaultt && !error) || error ){
            dispatch(
                showAlert({
                    id: 'AlertBox',
                    modalProps: {
                        icon:  error?.icon ? error.icon : 'redExclamation',
                        message : error ? error?.faMessage: defaultt.faMessage ,
                        title : error ? error?.faTitle:  defaultt.faTitle ,
                    },
                }),
            );
        }
    }


    return {
        displayErrorToast
    }
}